import { FC, useState } from 'react';
import { Button, Modal, RadioChangeEvent, Select } from 'antd';
import AddFittingSize from './AddFittingSize';
import FittingSizeList from './FittingSizeList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadFittingSizes } from './fittingSizeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { loadBodySizes } from '../bodySize/bodySizeSlice';
import { isUserAdmin } from '../../services/authenticationService';
import { AppState } from '../../redux/store/rootReducer';
import { loadMeasureUnit } from '../fittingtype/fittingTypeSlice';

const FittingSizePage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, editUser, setEditUser, setList } = React.useContext(CommonContext) as CommonContextType;
  const FittingSizes = useSelector(
    (state: AppState) => state.FittingSizes
  );
  const [selected, setSelected] = useState<any>('All')

  React.useEffect(() => {
    dispatch(loadFittingSizes());
    dispatch(loadBodySizes());
    dispatch(loadMeasureUnit());
  }, [dispatch]);

  React.useEffect(() => {
    setSelected("All")
  }, [FittingSizes]);

  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditUser(null)
    setModelChange(false);
  };

  const onChangeSizeType = (value: string) => {
    setSelected(value)
    setList(toggleFittingSizes(value))
  };

  const toggleFittingSizes = (data: string): any => () => {
    if (data !== 'All') {
      return FittingSizes.FittingSize.filter(item => item?.measure_unit.id == data);
      // return FittingSizes.FittingSize.filter(item => item.size_type?.toLowerCase() === data.toLowerCase());
    } else {
      return FittingSizes.FittingSize;
    }
  }

  return (
    <div className='padding'>
      {contextHolder}
      <h2>Connection Size List
        <Select
          defaultValue="All"
          style={{
            width: 120,
            marginLeft: 15,
          }}
          onChange={onChangeSizeType}
          value={selected}
          options={[
            {
              value: 'All',
              label: 'All',
            },
            {
              value: 1,
              label: 'Inch',
            },
            {
              value: 2,
              label: 'Metric',
            },
          ]}
        />
        {isUserAdmin() ? <button className='top-button' onClick={showModal}>Create</button> : null}
      </h2>
      <br></br>
      <FittingSizeList />
      <Modal title={editUser?.id ? 'Edit Size' : 'Create Size'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddFittingSize />
      </Modal>
    </div>
  );
};

export default FittingSizePage;